import { FBCourseStats, FBStepStats } from "JS/Models/Firebase/Courses";
import { courseFirebaseService } from "./CourseService";
import { bootstrapFirebaseService } from "JS/Helpers";

export const observeStepStats = (
    courseSkuId: string,
    stepSkuId: string,
    onObserve: (stats: FBStepStats) => void,
) => {
    bootstrapFirebaseService();
    courseFirebaseService.observeStepStats(courseSkuId, stepSkuId, onObserve);
};

export const observeCourseStats = (
    sku: string,
    onObserve: (stats: FBCourseStats) => void,
) => {
    bootstrapFirebaseService();
    courseFirebaseService.observeCourseStats(sku, onObserve);
};
